import { z } from 'zod'
import { Model } from './architecture'
import { Accommodation, type AccommodationType } from './Accommodation'

export const ListOfAccommodationValidation = z.object({
  list: z.instanceof(Accommodation, { message: 'list is required' }).array(),
})

// Tipos de alojamiento permitidos en los filtros de búsqueda
export const SEARCH_FILTER_ACCOMMODATION_TYPES = [
  'HOTEL',
  'RESORT',
  'APARTMENT',
  'VILLA',
  'HOMES',
  'HOSTEL',
  'APTHOTEL',
] as const

export type SearchFilterAccommodationType = (typeof SEARCH_FILTER_ACCOMMODATION_TYPES)[number]

export class ListOfAccommodation extends Model {
  static create({ list }: z.infer<typeof ListOfAccommodationValidation>) {
    ListOfAccommodationValidation.parse({ list })
    return new ListOfAccommodation(list)
  }

  static fromLegacyContext({ accommodations }: { accommodations?: string[] }) {
    return ListOfAccommodation.create({
      list:
        (accommodations
          ?.map(a => {
            try {
              return Accommodation.create({ value: a.toUpperCase() as AccommodationType })
            } catch {
              return null
            }
          })
          .filter(Boolean) as Accommodation[]) ?? [],
    })
  }

  static fromJSON({ json }: { json: ReturnType<ListOfAccommodation['toJSON']> }) {
    return ListOfAccommodation.create({
      list: json.list
        .map(accommodationJson => {
          try {
            return Accommodation.create({ value: accommodationJson.value as AccommodationType })
          } catch {
            return null
          }
        })
        .filter(Boolean) as Accommodation[],
    })
  }

  constructor(private readonly _list: Accommodation[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  map<T>(fn: (accommodation: Accommodation) => T) {
    return this._list.map(fn)
  }
}
